import { DrawerItemProps } from "./types";
import { DrawerLabel } from "./drawer-label";
import React from "react";

export const DrawerItem = ({
  title,
  path,
  icon,
  routes,
  isOpen,
  isActive,
  goTo,
}: DrawerItemProps): React.ReactElement => (
  <button onClick={() => goTo(path)} className="group relative">
    <DrawerLabel
      icon={icon}
      isOpen={isOpen}
      isActive={isActive}
      title={title}
    />
    {routes.length > 0 && (
      <div
        className={`hidden pt-2 group-hover:block ${
          isOpen ? "w-full pl-4" : "absolute top-full left-0 z-40"
        } `}
      >
        <div
          className={`transition-all duration-700 group-hover:visible  ${
            isOpen ? "" : "rounded-md bg-white py-[6px] px-2 shadow-xl"
          }`}
        >
          <div
            className={`border-l-2 ${
              isOpen
                ? "border-white bg-black text-white"
                : "border-black bg-white text-[#888888]"
            }`}
          >
            {routes.map((route, key) => (
              <button
                key={key}
                onClick={() => goTo(path, { screen: route.path })}
                className="my-2 ml-2 flex h-5 w-full min-w-max items-center rounded-md py-1 px-2 text-tiny font-light hover:bg-white hover:text-black"
              >
                {route.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    )}
  </button>
);
